import React, { Component } from "react";
import Vertical from "./vertical";

class VerticalSliderComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div className="container">
        <Vertical api={this.props} />
      </div>
    );
  }
}

export default VerticalSliderComponent;
